<template>
    <div :class="b()">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <el-button @click="addNode">Добавить</el-button>
                        <el-button @click="editNode">
                            Редактировать
                        </el-button>
                        <el-button @click="removeNode">
                            Удалить
                        </el-button>
                        <div :class="b('filter')">
                            <el-input
                                    placeholder="Наименование группы"
                                    v-model="filterText"
                                    default-expand-all>
                            </el-input>
                        </div>
                        <el-tree
                                ref="tree"
                                :data="superGroups"
                                node-key="guid"
                                v-loading="isLoading"
                                empty-text="Идет загрузка данных..."
                                :expand-on-click-node="true"
                                :filter-node-method="filterNode"
                                @node-click="selectedNodeChanged">
                        </el-tree>
                    </div>
                </div>
                <div class="col-md-5 col-md-offset-1 pt30 category-images" style="display: none;">
                    <div class="row">
                        <div class="col-md-12 mb30">
                            <h4 class="h4-cat">Картинки прообраза</h4>
                            <input v-on:keyup.enter="addCategoryImage" :data-id="curCat" type="text"
                                   class="form-control url-image-cat"
                                   placeholder="Вставьте ссылку на картинку и нажмите 'Enter'">

                            <div v-if="catInfo.images.length > 0">
                                <div class="row">
                                    <div class="col-xs-6 col-md-3" v-for="(image, index) in catInfo.images">
                                        <img class="img-thumbnail" :src="image.image">
                                        <a href="#" v-on:click="deleteImageCat" :data-image-id="image.id"
                                           :data-cat-id="curCat">Удалить</a>
                                    </div>
                                </div>
                            </div>
                            <div v-else>Картинок не найдено!</div>
                        </div>
                        <div class="col-md-12 mb30">
                            <h4 class="h4-cat">Описание</h4>
                            <editor
                                v-model="catInfo.description"
                                :api-key="this.$TINY_MCE_KEY"
                                rows="6"
                                ref="tm"
                                :data-id="curCat"
                                class="form-control url-image-cat"
                                placeholder="Вставьте описание для прообраза"
                                id="cat_description"
                            ></editor>

                            <button v-on:click="updateCategoryDescription" type="button" class="btn btn-primary">
                                Сохранить
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vuedals></vuedals>
    </div>
</template>

<script>
    import {default as Vuedals, Component as Vuedal, Bus as VuedalsBus} from 'vuedals';
    import Editor from '@tinymce/tinymce-vue';

    import TreeElementConverter from '../mixins/tree-element-converter';

    import CatalogService from '../services/CatalogService';
    import CategoryService from '../services/CategoryService';

    import NameModalComponent from './NameModalComponent';
    import AttributeModalComponent from './AttributeFormComponent';
    import {EventBus} from "../event-bus";

    import {Loading} from 'element-ui';

    const COMPONENT_NAME = 'catalog';

    const ELEMENT_TYPE_SUPER_GROUP = 1;
    const ELEMENT_TYPE_GROUP = 2;
    const ELEMENT_TYPE_SUB_GROUP = 3;
    const ELEMENT_TYPE_ATTRIBUTE = 4;

    const MODE_CREATE = 1;
    const MODE_EDIT = 2;

    export default {
        name: COMPONENT_NAME,
        mixins: [TreeElementConverter],
        components: {
            'vuedals': Vuedal,
            "editor": Editor
        },
        data() {
            return {
                superGroups: [],
                filterText: '',
                isLoading: false,
                catInfo: {
                    images: [],
                },
                curCat: null
            };
        },
        created() {
            EventBus.$on('name-edit', this.nameEvent);
            EventBus.$on('new-attribute', this.newAttribute);
            EventBus.$on('update-attribute', this.updateAttribute);
        },
        mounted() {
            this.getSuperGroups();
        },
        methods: {
            clearSelected() {
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(null);
                });

            },
            newAttribute(data) {
                this.$refs.tree.append(this.convertElement(data.attribute, ELEMENT_TYPE_ATTRIBUTE, data.parentId), data.parentId);
            },
            updateAttribute(data) {
                let parent = this.$refs.tree.getNode(data.parentId);
                parent.data.children.forEach((attribute) => {
                    if (attribute.id === data.attribute.id) {
                        attribute.name = data.attribute.name;
                        attribute.is_main = data.attribute.is_main;
                    }
                })
            },
            nameEvent(context, name, choose) {
                if (context.mode === MODE_CREATE) {
                    if (context.type === ELEMENT_TYPE_SUPER_GROUP) {
                        this.addSuperGroup(name, choose);
                    }

                    if (context.type === ELEMENT_TYPE_GROUP) {
                        this.addGroup(context.parent, name, choose);
                    }

                    if (context.type === ELEMENT_TYPE_SUB_GROUP) {
                        this.addSubGroup(context.parent, name, choose);
                    }
                }

                if (context.mode === MODE_EDIT) {
                    if ((context.type === ELEMENT_TYPE_SUPER_GROUP) || (context.type === ELEMENT_TYPE_GROUP)) {
                        this.updateGroup(context.node, name, choose);
                    }

                    if (context.type === ELEMENT_TYPE_SUB_GROUP) {
                        this.updateSubGroup(context.node, name, choose);
                    }
                }
            },
            async updateSubGroup(node, name, choose) {
                let response = await CatalogService.updateSubGroup(node.id, name, choose);
                if (response.success) {
                    node.label = name;
                } else {
                    this.$message(response.error.message);
                }
            },
            async updateGroup(node, name, choose) {
                let response = await CatalogService.updateGroup(node.id, name, choose);
                if (response.success) {
                    node.label = name;
                } else {
                    this.$message(response.error.message);
                }
            },
            async addSubGroup(parent, name, choose) {
                let response = await CatalogService.addSubGroup(parent.id, name, choose);
                if (response.success) {
                    this.$refs.tree.append(this.convertElement(response.subGroup, ELEMENT_TYPE_SUB_GROUP), parent.guid);
                } else {
                    this.$message(response.error.message);
                }
            },
            async addSuperGroup(name, choose) {
                let response = await CatalogService.addSuperGroup(name, choose);
                if (response.success) {
                    this.superGroups.push(this.convertElement(response.superGroup, ELEMENT_TYPE_SUPER_GROUP));
                } else {
                    this.$message(response.error.message);
                }
            },
            async addGroup(parent, name, choose) {
                let response = await CatalogService.addGroup(parent.id, name, choose);
                if (response.success) {
                    this.$refs.tree.append(this.convertElement(response.group, ELEMENT_TYPE_GROUP), parent.guid);
                } else {
                    this.$message(response.error.message);
                }
            },
            async removeSubGroup(node) {
                let response = await CatalogService.removeSubGroup(node.id);
                if (response.success) {
                    this.$refs.tree.remove(node.guid);
                } else {
                    this.$message('Не удалось удалить подгруппу');
                }
            },
            async getSuperGroups() {
                this.isLoading = true;
                let response = await CatalogService.getSuperGroups();
                this.isLoading = false;
                if (response.success) {
                    this.convertAll(response);
                }
            },
            convertAll(response) {
                let superGroups = this.convertElements(response.superGroups, ELEMENT_TYPE_SUPER_GROUP, null);
                this.$set(this, 'superGroups', superGroups);
                superGroups.forEach((superGroup) => {
                    let groups = this.convertElements(superGroup.groups, ELEMENT_TYPE_GROUP, superGroup.guid);
                    this.$set(superGroup, 'children', groups);
                    groups.forEach((group) => {
                        let categories = this.convertElements(group.categories, ELEMENT_TYPE_SUB_GROUP, group.guid);
                        this.$set(group, 'children', categories);
                        categories.forEach((category) => {
                            let attributes = this.convertElements(
                                category.allAttributes, ELEMENT_TYPE_ATTRIBUTE, category.guid
                            );

                            this.$set(category, 'children', attributes);
                        });
                    });
                });
            },
            async getGroups(node) {
                let guid = node.guid;
                let response = await CatalogService.getGroups(node.getRealId());
                if (response.success) {
                    let children = this.convertElements(response.groups, ELEMENT_TYPE_GROUP, guid);
                    this.fillChildren(children, guid);
                    this.requestChild(children);
                }
            },
            async getSubGroups(node) {
                let guid = node.guid;
                let response = await CatalogService.getSubGroups(node.getRealId());
                if (response.success) {
                    let children = this.convertElements(response.subGroups, ELEMENT_TYPE_SUB_GROUP, guid);
                    this.fillChildren(children, guid);
                    this.requestChild(children);
                }
            },
            async getAttributes(node) {
                let guid = node.guid;
                let response = await CatalogService.getAttributes(node.getRealId());
                if (response.success) {
                    let children = this.convertElements(response.attributes, ELEMENT_TYPE_ATTRIBUTE, guid);
                    this.fillChildren(children, guid);
                }
            },
            async removeAttribute(node) {
                let parent = this.$refs.tree.getNode(node.parentId);
                let response = await CatalogService.removeAttribute(node.getRealId(), parent.data.id);
                if (response.success) {
                    this.$refs.tree.remove(node.guid);
                    this.$notify({message: 'Атрибут удален'});
                }
            },
            async getInfoSubGroup(catId) {
                let response = await CategoryService.getCategoryInfo(catId);

                this.catInfo = response.cat;

                if(!this.catInfo.description) {
                    this.catInfo.description = '';
                }
            },
            requestChild(children) {
                children.forEach((group) => {
                    if (group.type === ELEMENT_TYPE_SUPER_GROUP) {
                        this.getGroups(group);
                    } else if (group.type === ELEMENT_TYPE_GROUP) {
                        this.getSubGroups(group);
                    } else if (group.type === ELEMENT_TYPE_SUB_GROUP) {
                        this.getAttributes(group);
                    }
                })
            },
            fillChildren(children, parentId) {
                let node = this.$refs.tree.getNode(parentId);
                if (node) {
                    if (node.data.children.length === 0) {
                        children.forEach((child) => {
                            this.$refs.tree.append(child, parentId);
                        })
                    }
                }
            },
            selectedNodeChanged(node) {

                this.curCat = node.id;

                // Обновим отображение блока загрузки картинок, в зависимости от того какая что выбрано в дереве
                this.updateVisibleImagesBlockCat(node);

                if (node && node.type === ELEMENT_TYPE_SUPER_GROUP) {
                    this.getGroups(node);
                }

                if (node && node.type === ELEMENT_TYPE_GROUP) {
                    this.getSubGroups(node);
                }

                if (node && node.type === ELEMENT_TYPE_SUB_GROUP) {

                    // Подгрузка картинок для прообраза с помощью отдельного запроса. Это для того что бы заново не строить дерево
                    this.getInfoSubGroup(node.id);

                    this.getAttributes(node);
                }

                if (node && node.type === ELEMENT_TYPE_ATTRIBUTE) {
                    this.editNode();
                }
            },
            updateVisibleImagesBlockCat(node) {
                if (node && (node.type === ELEMENT_TYPE_SUB_GROUP) || node.type === ELEMENT_TYPE_ATTRIBUTE) {
                    $('.category-images').show();
                } else {
                    $('.category-images').hide();
                }
            },
            removeNode() {
                let node = this.$refs.tree.getCurrentNode();
                if (node.children && node.children.length > 0) {
                    this.$message('Нельзя удалить группу в которой есть дочерние элементы');
                    return;
                }

                if (!window.confirm('Вы действительно хотите удалить группу?')) {
                    return;
                }

                if (node && (node.type === ELEMENT_TYPE_SUPER_GROUP || node.type === ELEMENT_TYPE_GROUP)) {
                    this.removeGroup(node);
                }

                if (node && node.type === ELEMENT_TYPE_SUB_GROUP) {
                    this.removeSubGroup(node);
                }

                if (node && node.type === ELEMENT_TYPE_ATTRIBUTE) {
                    this.removeAttribute(node);
                }
            },
            addNode() {
                let parent = this.$refs.tree.getCurrentNode();
                let context = {
                    mode: MODE_CREATE,
                    parent: parent
                };

                if (_.isNull(parent) || _.isUndefined(parent)) {
                    context.type = ELEMENT_TYPE_SUPER_GROUP;
                } else if (parent.type === ELEMENT_TYPE_SUPER_GROUP) {
                    context.type = ELEMENT_TYPE_GROUP;
                } else if (parent.type === ELEMENT_TYPE_GROUP) {
                    context.type = ELEMENT_TYPE_SUB_GROUP;
                } else {
                    context.type = ELEMENT_TYPE_ATTRIBUTE;
                }

                VuedalsBus.$emit('new', this.getModalFormSetup(context, null, parent));
            },
            editNode() {
                let node = this.$refs.tree.getCurrentNode();
                let parent = _.isNull(node.parentId) ? null : this.$refs.tree.getNode(node.parentId);
                if (_.isNull(node) || _.isUndefined(node)) {
                    this.$message('Выберите группу для редактирования');
                    return;
                }
                let context = {
                    mode: MODE_EDIT,
                    node: node,
                    type: node.type
                };

                VuedalsBus.$emit('new', this.getModalFormSetup(context, node, parent ? parent.data : null));
            },
            getModalFormSetup(context, node, parent) {
                let editForm = NameModalComponent;
                let props = {
                    context: context,
                    value: node ? node.label : ''
                };

                if (context.type === ELEMENT_TYPE_ATTRIBUTE) {
                    editForm = AttributeModalComponent;
                    props = {
                        attribute: node,
                        category: parent,
                        context: context
                    };
                }

                return {
                    props: props,
                    name: 'category-form',
                    component: editForm
                };
            },
            filterNode(value, data) {
                if (!value) return true;

                let inParent = false;
                if (!_.isNull(data.parentId)) {
                    let parent = this.$refs.tree.getNode(data.parentId);
                    inParent = this.filterNodeParents(parent, value);
                }

                return inParent || data.label.indexOf(value) !== -1;
            },
            filterNodeParents(parent, value) {
                if (_.isNull(parent)) return false;

                let hasParent = !_.isNull(parent.data.parentId);
                let inParent = hasParent;
                if (hasParent) {
                    inParent = this.filterNodeParents(this.$refs.tree.getNode(parent.data.parentId), value);
                }

                return parent.data.label.indexOf(value) !== -1 || inParent;
            },
            getElementClass(data) {
                return 'el-icon-folder';
            },
            async removeGroup(node) {
                let response = await CatalogService.removeGroup(node.id);
                if (response.success) {
                    this.$refs.tree.remove(node.guid);
                    this.$message('Группа удалена');
                } else {
                    this.$message('Не удалось удалить группу');
                }
            },
            async deleteImageCat(event) {
                event.preventDefault();

                let target = $(event.target),
                    imageId = target.data('image-id');

                let response = await CategoryService.removeCategoryImage(imageId);

                if (response.success) {
                    this.getInfoSubGroup(this.curCat);
                } else {
                    this.$message(response.error.message);
                }
            },
            async addCategoryImage(event) {
                let target = $(event.target),
                    catId = target.attr('data-id'),
                    src = target.val();

                if (!catId) {
                    alert('Сначала выберите прообраз товара');
                    return;
                }

                if (!src) {
                    alert('Вставьте ссылку на картинку');
                    return;
                }

                // Проверим регуляркой на всякий случай ссылку на изображение, а то встречаются Base64, да и мало ли ошибется человек
                // let reg = new RegExp("(http(s?):)([/|.|a-zа-я0-9|-\\w|\\s])*\\.(?:gif|jpg|jpeg|tiff|png)", 'gi');
                let reg = new RegExp("(http(s?):)([/|.|a-zа-я0-9|-\\w|\\s])*\\.(?:gif|jpg|jpeg|tiff|png)?", 'gi');
                if (!reg.test(src)) {
                    this.$notify({message: 'Некорректная ссылка на картинку. Проверьте правильность URL', type: 'fail'});
                    return;
                }

                let response = await CategoryService.addCategoryImage(catId, src);

                if (response.success) {
                    target.val('');
                    this.getInfoSubGroup(this.curCat);
                } else {
                    this.$message(response.error.message);
                }
            },
            async updateCategoryDescription(event) {
                let target = $('#cat_description'),
                    catId = target.data('id');

                if (!catId) {
                    this.$notify({message: 'Сначала выберите прообраз товара', type: 'fail'});
                    return;
                }

                if (!this.catInfo.description) {
                    this.$notify({message: 'Введите описание для прообраза', type: 'fail'});
                    return;
                }

                let response = await CategoryService.updateCategoryDescription(catId, this.catInfo.description);

                if (response.success) {
                    this.$notify({message: 'Успешное сохранение'});
                    this.getInfoSubGroup(this.curCat);
                } else {
                    this.$message(response.error.message);
                }
            }
        },
        watch: {
            filterText: {
                handler(val) {
                    this.$refs.tree.filter(val);
                }
            }
        }
    }
</script>

<style lang="scss">
    .catalog {
        display: flex;

        &__filter {
            padding: 10px 0;
        }

        .catThumb img {
            height: 100px;
        }

        .url-image-cat {
            margin-bottom: 10px;
        }

        .h4-cat {
            margin-bottom: 20px;
        }

        .pt30 {
            padding-top: 30px;
        }

        .is-current > .el-tree-node__content {
            background-color: #F5F7FA;
        }

        .mb30 {
            margin-bottom: 30px;
        }

    }
</style>